/**
 * Ô "Chia sẻ" — số người được chia sẻ, bấm vào là ra đúng danh sách ấy.
 *
 * **Chủ dự án**: *"ở trang tên miền và trang sub-domain thêm cho tôi cột hiển
 * thị số người được chia sẻ domain đó, khi bấm vào số thì ra trang danh sách"*.
 *
 * ── Vì sao là một component dùng chung, không phải hai đoạn JSX giống nhau ──
 *
 * Hai bảng, cùng một câu hỏi, nên phải cùng một câu trả lời. Chép qua chép lại
 * là cách chắc chắn để vài tuần nữa hai trang đếm khác nhau — và bên nào cũng
 * trông có lý khi nhìn riêng. Trong phiên này đã ba lần trả giá cho bản chép
 * thiếu thứ không nhìn thấy được từ ảnh.
 *
 * ── Con số phải khớp cái mà trang đích hiện ra ─────────────────────────────
 *
 * Cả hai trang đích đều liệt kê **hai nhóm**: người đang giữ quyền và người mới
 * được mời, chưa kích hoạt. Nên ô này cộng cả hai. Đếm thiếu nhóm sau thì người
 * bấm vào số 0 lại mở ra ba dòng, và lần sau họ không tin cột này nữa (bài học
 * OQ-313).
 *
 * Con số gộp lại thì `title` tách ra, để chỗ nào cần chính xác vẫn tra được.
 */

import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../lib/i18n';
import { useFormat } from '../lib/format';

export function ShareCountCell({
  count,
  pending,
  to,
  odId,
}: {
  /** Người đang giữ quyền — đã kích hoạt tài khoản. */
  count: number;
  /** Lời mời còn hiệu lực. */
  pending: number;
  /** Trang danh sách tương ứng, mở sẵn đúng tab. */
  to: string;
  odId: string;
}): JSX.Element {
  const t = useT();
  const { formatNumber } = useFormat();
  const tong = count + pending;

  /* Chưa chia sẻ cho ai thì đừng dựng một cái link dẫn tới bảng rỗng. */
  if (tong === 0) return <span className="muted">—</span>;

  return (
    <Link
      to={to}
      title={t('share.cell.title', { n: formatNumber(count), p: formatNumber(pending) })}
      data-od-id={odId}
    >
      {formatNumber(tong)}
      {pending > 0 ? (
        /* Dấu hiệu "chưa xong" ngay trên bảng: một phần con số này là lời hứa,
           chưa phải người đang dùng được. */
        <span className="sub" style={{ marginLeft: 4 }}>
          ({t('share.cell.pendingShort', { p: formatNumber(pending) })})
        </span>
      ) : null}
    </Link>
  );
}
